// File: IoT-User-Frontend/src/composables/useChart.js

import * as echarts from "echarts";

export function useChart() {
  let chart = null;
  let resizeObserver = null;

  const initChart = (el) => {
    chart = echarts.init(el);
    // Observe parent container for size changes
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
    resizeObserver = new ResizeObserver(() => {
      chart && chart.resize();
    });
    if (el && el.parentElement) {
      resizeObserver.observe(el.parentElement);
    }
    // Still listen to window resize for safety
    window.addEventListener("resize", () => chart && chart.resize());
  };

  const updateChart = (options) => {
    chart && chart.setOption(options);
  };

  const getChartInstance = () => chart;

  return { initChart, updateChart, getChartInstance };
}
